import { useDealPortfolioStore } from "..";
import { showErrorToast, showSuccessToast } from "../components/ToastContainer";
import IDealPortfolio, { IDealPortfolioState } from "../interfaces/IDealPortfolio";

const useDealPortfolioCreate = (): (state: IDealPortfolioState) => Promise<IDealPortfolio> => {
    const dealPortfolioStore = useDealPortfolioStore();

    return async (state: IDealPortfolioState): Promise<IDealPortfolio> => {
        try {
            const portfolio = await dealPortfolioStore.createPortfolio(state);
            showSuccessToast();
            return portfolio;
        } catch (e) {
            showErrorToast();
            throw e;
        }
    };
};

export default useDealPortfolioCreate;
